
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/archive/2022-temp",
      function () {
        return require("private-next-pages/archive/2022-temp.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/archive/2022-temp"])
      });
    }
  